import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CitationItem',
    props: {
        citation: null,
        outputFormat: { default: "bibliography" },
        prefix: { default: "" }
    },
    setup(__props) {
        const props = __props;
        library.add(faExternalLinkAlt);
        const link = computed(() => {
            var _a, _b, _c;
            const citeUrl = (_c = (_b = (_a = props.citation.cite) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.URL;
            return citeUrl ? decodeURIComponent(citeUrl) : null;
        });
        const citationHtml = computed(() => {
            const citation = props.citation;
            const cite = citation.cite;
            const formattedCitation = cite.format(props.outputFormat, {
                format: "html",
                template: "apa",
                lang: "en-US",
            });
            return formattedCitation;
        });
        return { __sfc: true, props, link, citationHtml, faExternalLinkAlt, FontAwesomeIcon };
    }
});
